var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#alert_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.722 2.5 7.938 13.75a.834.834 0 0 1-.721 1.25H2.062a.834.834 0 0 1-.722-1.25L9.278 2.5a.833.833 0 0 1 1.444 0ZM3.505 15.833h12.99L10 4.583l-6.495 11.25Zm5.662-2.5h1.667V15H9.167v-1.667Zm0-5.833h1.667v4.167H9.167V7.5Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "alert_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgAlert;